import React from "react";
import styled from "styled-components";
// import componentQueries from "react-component-queries";
import { Flex, Box } from "rebass";

const Container = styled.div`
  margin-top: 1rem;
  // box-shadow: 1px 1px 3px 1px rgba(0,0,0,0.13);
`;

export default class InstaImage extends React.Component {
  state = {
    data: {
      loading: true,
      data: null,
      error: false
    },
    image: {
      loading: true,
      data: null,
      error: false
    }
  };

  componentWillMount() {
    if (typeof window !== "undefined") {
      const API = "https://api.instagram.com/oembed/?url=";
      const url = `${API}${this.props.url}`;
      fetch(url)
        .then(res => {
          return res.json();
        })
        .then(json => {
          this.setState({
            loading: false,
            data: json
          });
        })
        .catch(() => {
          this.setState({
            error: true,
            loading: false
          });
        });
    }
  }

  handleImageLoad = () => {
    if (this.props.onLoad) {
      this.props.onLoad();
    }
  };

  handleImageError = () => {
    console.warn("failed to load image", this.props.url);
    this.setState({
      image: {
        ...this.state.image,
        error: true
      }
    });
  };

  render() {
    const { data, image } = this.state;
    const { f } = this.props;

    if (data.loading || data.error || image.error) {
      return null;
    }

    /* eslint jsx-a11y/alt-text: off  */
    return (
      <Container>
        <a href={this.props.url}>
          <img
            width="100%"
            src={this.state.data.thumbnail_url}
            onLoad={this.handleImageLoad}
            onError={this.handleImageError}
          />
        </a>
        <Flex f={f} style={{ color: "darkgray" }} mt={1} column>
          <Box>{this.state.data.title}</Box>
          <Box>
            <a target="_blank" href={this.state.data.author_url}>
              @{this.state.data.author_name}
            </a>
          </Box>
        </Flex>
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/insta-image.js